import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ContentService } from 'src/app/services/content/content.service';
import { CenterSectionComponent } from 'src/app/shared/components';
import { ContentSection } from '../../../shared/layout/content-section';
import { SanitizeHtmlPipe } from '../../../shared/pipes/sanitize-html.pipe';

@Component({
  selector: 'app-trade-conditions',
  templateUrl: './trade-conditions.component.html',
  styleUrls: ['./trade-conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CenterSectionComponent, SanitizeHtmlPipe],
})
export class TradeConditionsComponent extends ContentSection implements OnInit {
  title: string;
  body: string;

  constructor() {
    const contentService = inject(ContentService);
    super(contentService, 'limitationOfLiability', { meta: true });
  }

  ngOnInit() {
    this.title = this.content.get('titleText');
    this.body = this.contentService.addImageSource(this.content.get('descriptionText'));
  }
}
